import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useTranslation } from 'react-i18next';
import { useMuseum } from '@/features/museum/context/MuseumContext';
import { useImageUrl } from '@/shared/hooks/useImageUrl';

export const LoginPage: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { museumSlug } = useParams<{ museumSlug?: string }>();
  const { museum } = useMuseum();
  const logoUrl = useImageUrl(museum?.logo);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    if (!museumSlug) {
      setError('museumSlug is required');
      return;
    }

    try {
      await login(museumSlug, email, password);
      const redirectPath = museumSlug ? `/${museumSlug}` : '/';
      navigate(redirectPath);
    } catch (err) {
      setError(t('auth.loginError'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-content">
        {logoUrl && (
          <img src={logoUrl} alt={museum?.name?.['fr'] || museum?.name?.['en'] || 'Logo'} className="museum-logo" />
        )}
        <div className="login-container">
          <h1>{t('common.introText')}</h1>
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="email">{t('auth.email')}</label>
              <input
                id="email"
                type="email"
                autoComplete="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="password">{t('auth.password')}</label>
              <input
                id="password"
                type="password"
                autoComplete="current-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>
            {error && <div className="error-message">{error}</div>}
            <button type="submit" disabled={loading} className="btn-primary">
              {loading ? t('common.loading') : t('auth.login')}
            </button>
          </form>
        </div>
        <div className="connection-info">
          <p>{t('auth.connectionInfo')}</p>
          <a href="mailto:support@oratoria-audioguide.com" className="contact-link">{t('auth.contactSupport')}</a>
        </div>
        <div className="footer">
          <p>{t('common.footerText')} <a href="https://oratoria-audioguide.com" target="_blank" rel="noopener noreferrer">{t('common.oratorio')}</a></p>
        </div>
      </div>
    </div>
  );
};

